var /**
     *
     * @type {string}
     */
    DEFAULT_DOMAIN = '.edmunds.com',

    /**
     *
     * @type {string}
     */
    DEFAULT_COOKIE_PATH = '/',

    cookies = require('../cookies/cookies');

/**
 * Check if visitor cookie already set and return it's value
 * @return {*}
 */
function checkVisitorIdCookie() {
    return cookies.getItem('edmunds');
}

/**
 * Check if session cookie already set and return it's value
 * @return {*}
 */
function checkSessionIdCookie() {
    return cookies.getItem('edw');
}

/**
 * Generate unique 38 char length combination for visitor id
 * @return {string}
 */
function generateVisitorId() {
    for (var e = '0123456789abcdefghijklmnopqrstuvwxyz', t = 38, n = '', r = 0; t > r; r++) {
        var o = Math.floor(Math.random() * e.length);
        n += e.substring(o, o + 1);
    }
    return n;
}

/**
 * Generate unique number for session id
 * @return {number}
 */
function generateSessionId() {
    return Math.ceil(Math.random() * Math.random() * Math.random() * Date.now() * 1e6);
}

/**
 * Set Edmunds specific cookie item
 * @param name
 * @param value
 * @param expiresAfter
 */
function addEdmundsCookie(name, value, expiresAfter) {
    cookies.setItem(name, value, new Date(Date.now() + expiresAfter), DEFAULT_COOKIE_PATH, DEFAULT_DOMAIN);
}

/**
 * Sets visitor cookie and returns value back
 * @return {string}
 */
function setAndGetVisitorCookie() {
    var visitorId = generateVisitorId();
    addEdmundsCookie('edmunds', visitorId, 31536e6);
    return visitorId;
}

/**
 * Sets session cookie and returns value back
 * @return {number}
 */
function setAndGetSessionCookie() {
    var sessionId = generateSessionId();
    addEdmundsCookie('edw', sessionId, 18e5);
    return sessionId;
}

/**
 *
 * @param {{ visitor: { id: string, session: number } }} EDM - window.EDM global object used for global
 * @return {{addVisitorId: addVisitorId, addSessionId: addSessionId}}
 */
module.exports = function setVisitorContext(EDM) {

    return {
        /**
         * Check if visitor id already set in cookies, otherwise generate it and set to cookies
         */
        addVisitorId: function () {
            EDM.visitor.id = checkVisitorIdCookie() || setAndGetVisitorCookie();
            return this;
        },

        /**
         * Check if session id already set in cookies, otherwise generate it and set to cookies
         */
        addSessionId: function () {
            EDM.visitor.session = checkSessionIdCookie() || setAndGetSessionCookie();
            return this;
        }
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/utils/visitor-context/visitor-context.js
// module id = 332
// module chunks = 36